// 格式化日期格式
function parseTime(date, format) {
  if (!date) {
    return "";
  }
  let curDate = new Date(date);
  const o = {
    "M+": curDate.getMonth() + 1, // 月份
    "d+": curDate.getDate(), // 日
    "h+": curDate.getHours() >= 10 ? curDate.getHours() : "0" + curDate.getHours(), // 小时
    "m+": curDate.getMinutes() >= 10 ? curDate.getMinutes() : "0" + curDate.getMinutes(), // 分
    "s+": curDate.getSeconds() >= 10 ? curDate.getSeconds() : "0" + curDate.getSeconds(), // 秒
    "q+": Math.floor((curDate.getMonth() + 3) / 3), // 季度
    S: curDate.getMilliseconds(), // 毫秒
  };
  if (/(y+)/.test(format)) {
    format = format.replace(RegExp.$1, (curDate.getFullYear() + "").substr(4 - RegExp.$1.length));
  }
  for (let k in o) {
    if (new RegExp("(" + k + ")").test(format)) {
      format = format.replace(RegExp.$1, RegExp.$1.length === 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length));
    }
  }
  return format;
}
function getParentIds(list, id, key = "id", parentId = "parentId") {
  let temp = [];
  let forFn = function (arr, id) {
    for (let i = 0; i < arr.length; i++) {
      let item = arr[i];
      if (item[key] === id) {
        forFn(list, item[parentId]);
        temp.push(item[key]);
        break;
      } else {
        if (item.children) {
          forFn(item.children, id);
        }
      }
    }
  };
  forFn(list, id);
  return temp;
}
function getDomContentWidth(dom) {
  const style = window.getComputedStyle(dom);
  const paddingWidth = parseFloat(style.paddingLeft) + parseFloat(style.paddingRight);
  const width = dom.clientWidth - paddingWidth;
  return width;
}

function getOrCreateMeasureDom(id, init) {
  let dom = document.getElementById(id);
  if (!dom) {
    dom = document.createElement("span");
    dom.style.position = "absolute";
    dom.style.wordBreak = "break-word";
    dom.style.fontSize = "14px";
    dom.style.transform = "translateY(-200vh)";
    dom.style.pointerEvents = "none";
    dom.style.opacity = "0";
    dom.id = id;
    document.body.appendChild(dom);
    init?.(dom);
  }

  return dom;
}

export function autoGrowTextArea(dom) {
  const measureDom = getOrCreateMeasureDom("__measure");
  const singleLineDom = getOrCreateMeasureDom("__single_measure", (dom) => {
    dom.innerText = "TEXT_FOR_MEASURE";
  });

  const width = getDomContentWidth(dom);
  measureDom.style.width = width + "px";
  measureDom.innerText = dom.value !== "" ? dom.value : "1";
  measureDom.style.fontSize = dom.style.fontSize;
  const endWithEmptyLine = dom.value.endsWith("\n");
  const height = parseFloat(window.getComputedStyle(measureDom).height);
  const singleLineHeight = parseFloat(window.getComputedStyle(singleLineDom).height);

  const rows = Math.round(height / singleLineHeight) + (endWithEmptyLine ? 1 : 0);

  return rows;
}

// 获取一个指定长度的随机字符串
export function getRandomString(len = 26) {
  if(len <= 11) {
    return Math.random().toString(36).slice(2, 2+len).padEnd(len, '0')
  }else {
    return getRandomString(11) + getRandomString(len - 11)
  }
}

export { parseTime, getParentIds };
